export const about = {
  heading: "Hey, I'm Tomas.",

  statueUrl: "https://x.com/PezRadar/status/1717019368268104074",

  // Paragraphs shown before the statue embed.
  intro: [
    "I also like to play action RPGs, on hardcore and sometimes competitively. This is my gamer tag (Mirtis#1342) on the statue of Lilith at Blizzard headquarters:",
  ],

  // Paragraphs shown after the statue embed.
  body: [
    "So what do games have to do with code?",
    "Hardcore is permadeath: one mistake and the character is gone for good, hours of progress with it. Imagine if every time you shipped a bug to production, your whole codebase was deleted and you had to rewrite it from scratch. Do you think it would make you a better engineer?",
    "That's the mindset I've taken from it, alongside ten years in tech across development, hardware, and support: write robust code that minimizes bugs, make the important choices early (reaching for Rust on heavy AI or low-level work, say, to rule out an entire class of problems), and build in observability, logging, and testing by default.",
    "And it matters more now, not less. AI lets us write more code faster than ever, which makes the judgment to catch what will break, and the discipline to test and review before shipping, the part that actually counts.",
  ],

  // Closing call to action; the link half points at site.email.
  cta: {
    lead: "Like what you see?",
    link: "Let's chat.",
  },
} as const;
